import React, { useState } from "react";
import { PopupMain } from "../../components/popup/PopupMain";
import { useNavigate } from "react-router-dom";

const PaymentComplete = () => {
//   const [openAlert, setOpenAlert] = useState(true);
const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(/images/circle.png)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left 60%",
      }}
      className="bg-white min-h-screen font-IBMPlexSansThai mt-[79px] pt-[36px] px-[32px] "
    >
      <PopupMain
        open={true}
        text={`ขอขอบคุณที่สมัครสมาชิกพรีเมี่ยมกับเรา\nเราขอให้เป้าหมายทางการเงินของคุณ\nเป็นไปตามที่ตั้งไว้`}
        img={"/images/smile.svg"}
        textButton={"ตกลง"}
        onClick={()=>{
            localStorage.clear();
            window.location.reload();
            navigate("/login");
        }}
        // button2
        // textButton2={"ยกเลิก"}
        // onClickSecond={() => setOpenAlert(false)}
      />
    </div>
  );
};

export default PaymentComplete;
